var a="fw_appearance_variant";export{a};
//# sourceMappingURL=chunk-O2VJ4XTD.js.map